import React from "react";
import './mainSettingsUsers.css'
import {useNavigate} from "react-router-dom";
import UsersTable from "./subElements/mainUsersTable";
import {pathImpostazioni, subPathUsers} from "../../configurations/setting";
import Select from "../../components/userManagement/select/Select";

const SettingsUsers = () => {

    const navigate = useNavigate();

    const showUser = (row) => {
       
        navigate(`${pathImpostazioni}/${subPathUsers}/${row.id}`);

    };
   
    return (

        <div className="mainSettingsUsers">
            <div className="sidebarSettings">
                <div className="sidebarSettingsContent">
                    <svg width="1.5vw" height="1.4vw" viewBox="0 0 22 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
                            stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span 
                    className={"sidebar"}
                    style={{fontSize:"1.5vw", fontWeight:"bold", margin:"0.5vw 1vw", borderRadius:"5px"}}
                    >Users</span>

                </div>
            </div>
            <div className="mainSettingsUsersBody">
                <UsersTable showUser={showUser}/>
            </div>

        </div>
    )


}

export default SettingsUsers;